import PropTypes from 'prop-types';
import * as analytics from 'Utils/analytics';
import NoProfileData from 'Components/profile/NoProfileData';
const { EVENTS } = analytics;
const CTA_URLS = {
  SHOWS: process.env.REACT_APP_LIBRARY_CTA_SHOWS_URL,
  FILMS: process.env.REACT_APP_LIBRARY_CTA_FILMS_URL,
  EVENTS: process.env.REACT_APP_LIBRARY_CTA_EVENTS_URL,
  CLIPS: process.env.REACT_APP_LIBRARY_CTA_CLIPS_URL,
  STORIES: process.env.REACT_APP_LIBRARY_CTA_STORIES_URL,
};

const NoLibraryData = ({
  cta,
  type,
  typeTranslation,
  youAddToYourLibrary,
  youHaventAddedAny,
}) => {
  const handleClick = () => {
    analytics.event({
      action: EVENTS.selectLibraryDiscover,
      label: type.toLowerCase(),
    });
  };

  return (
    <NoProfileData
      body={youAddToYourLibrary.formatUimTranslation(typeTranslation)}
      className="no-profile-data__library"
      heading={youHaventAddedAny.formatUimTranslation(typeTranslation)}
    >
      <a
        className="button btn--short"
        href={CTA_URLS[type]}
        onClick={handleClick}
      >
        {cta.formatUimTranslation(typeTranslation)}
      </a>
    </NoProfileData>
  );
};

NoLibraryData.propTypes = {
  cta: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  typeTranslation: PropTypes.string.isRequired,
  youAddToYourLibrary: PropTypes.string.isRequired,
  youHaventAddedAny: PropTypes.string.isRequired,
};

NoLibraryData.defaultProps = {};

export default NoLibraryData;
